<template>
  <div class="panel-body">
    <div class="form-group m-0">
      <router-link class="btn btn-sm btn-success" :to="{ name: `userCreate`}">
        <i class="fa fa-plus" aria-hidden="true"></i> {{ $t('words.create') }}</router-link>
    </div>
    <div class="row">
      <div class="col-md-12">
        <filterable @loading="changeLoading" ref="filter" v-bind="filterable">
          <thead slot="thead">
            <tr>
              <th>{{$t('words.options')}}</th>
              <th>{{$t('attributes.name')}}</th>
              <th>{{$t('attributes.document')}}</th>
              <th>Cargo</th>
              <th>Login</th>
              <th>Status</th>
              <th>{{$t("words.company")}}</th>
            </tr>
          </thead>
          <tr slot-scope="{item, dropup}">
            <td class="column-options">
              <div class="btn-group" :class="{'dropup': dropup}">
                <button :disabled="item.id == auth_user.id && auth_user.ambiente !== 'A'" type="button"
                  class="btn btn-default btn-sm dropdown-toggle" v-bind:title="$t('words.operations')"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-bars" aria-hidden="true"></i>
                  <span class="caret"></span>
                </button>
                <div class="dropdown-menu">
                  <!--  <li>
                    <a @click="getById(item.id)"><i class="fa fa-eye"></i>{{$t('words.details') }}</a>
                  </li>
                  -->
                  <router-link :to="{ name: `userEdit`, params: { id: item.id}}" class="dropdown-item"
                    v-if="allow('USUARIOS') && item.status !== 2">
                    <i class="fa fa-pencil"></i> {{$t('words.edit')}}</router-link>
                  <a class="dropdown-item" v-if="item.id !== auth_user.id && auth_user.ambiente">
                    <span v-if="item.status == 1" @click="disableUser(item.id)">
                      <i class="fa fa-times" aria-hidden="true"></i> {{$t('words.disable')}}
                    </span>
                    <span v-if="item.status == 0" @click="disableUser(item.id)">
                      <i class="fa fa-check" aria-hidden="true"></i> {{$t('words.enable')}}</span>
                  </a>
                  <router-link :to="{ name: `userPermissions`, params: { id: item.id}}" class="dropdown-item"
                    v-if="allow('PERMISSOES') && item.status !== 2">
                    <i class="fa fa-lock" aria-hidden="true"></i> {{$t('words.permissions')}}</router-link>
                  <a v-if="item.status == 2" @click="reenviarLink(item)">
                    <i class="fa fa-send-o" aria-hidden="true"></i> Reenviar convite</a>
                  <a class="dropdown-item" @click="cancelarConvite(item.id)" v-if="item.status == 2">
                    <i class="fa fa-times" aria-hidden="true"></i> Cancelar convite</a>
                  <a class="dropdown-item" @click="removeBind(item)" v-if="allow('USUARIOS') && item.status !== 2">
                    <i class="fa fa-trash"></i> Remover Vínculo</a>
                </div>
              </div>
            </td>
            <td><img class="img-circle" :src="item.avatar" style="width:35px" alt="User Image"> {{item.nome}}</td>
            <td>{{item.documento}}</td>
            <td><span v-if="item.cargo">{{item.cargo.cargo_nome}}</span><span v-else>Simples Signatário</span></td>
            <td>{{item.email}}</td>
            <td>
              <span v-if="item.status == 1" class="badge bg-green"><i class="fa fa-check "></i> Ativo</span>
              <span v-if="item.status == 0" class="badge bg-red"><i class="fa fa-times"></i> Desativado</span>
              <span v-if="item.status == 2" class="badge bg-orange"><i class="fa fa-clock-o"></i> Aguardando
                Convite</span>
            </td>
            <td><span v-if="item.empresa">{{item.empresa.empresa_nome}}</span><span v-else>Simples Signatário</span>
            </td>
          </tr>
        </filterable>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        filterable: {
          deleted: false,
          storeAction: 'setUsers',
          storeName: 'user.index',
          model: 'user',
          url: '/api/usuarios',
        },
        details: '',
        importHeaders: {
          description: {
            field: this.$t('words.description'),
            required: true,
            description: 'Descrição do Pessoa, máximo de caracteres: 120'
          },
          day: {
            field: this.$t('words.day'),
            required: true,
            description: 'Dia do Pessoa, valores entre 1-31'
          },
          month: {
            field: this.$t('words.month'),
            required: true,
            description: 'Mes do Pessoa, valores entre 1-12'
          },
          year: {
            field: this.$t('words.year'),
            required: false,
            description: 'Ano do Pessoa (opcional)'
          }
        }
      };
    },
    watch: {
      $route(data) {
        if (data.name === 'usuarios') {
          this.prepareComponent();
        }
      }
    },
    methods: {
      reenviarLink(item) {
        this.$refs.filter.loading = true;
        this.$store
          .dispatch('storeUser', item)
          .then(response => {
            console.log(response);
            this.$refs.filter.loading = false;
            toastr({
              icon: response.status,
              title: response.message
            });
          });
      },
      cancelarConvite(id) {
        this.$refs.filter.loading = true;
        this.$store
          .dispatch('cancelInvite', id)
          .then(response => {
            console.log(response);
            this.$refs.filter.loading = false;
            this.prepareComponent();
            toastr({
              icon: response.status,
              title: response.message
            });
          });
      },
      removeBind(payload) {
         Swal.fire({
          title: trans('words.atention'),
          html: `Remover o usuário <b>${payload.nome}</b> do vínculo da Empresa <br>
            <small> OBS: Confirmando, os arquivos do usuário serão transferidos para você
            e o acesso e níveis do usuário serão deletados <b>permanentemente.</b><br>
            Caso você queira reintegrar o usuário futuramente, basta realizar o processo de cadastro novamente.</small>`,
          icon: 'warning',
          input: 'text',
          inputPlaceholder: 'Digite CONFIRMA para continuar',
          showCancelButton: true,
          allowOutsideClick: true,
          cancelButtonText: trans('words.close'),
          confirmButtonText: 'Confirmar',
          confirmButtonClass: 'btn btn-danger btn-lg float-right',
          cancelButtonClass: 'btn btn-default btn-lg float-left',
          buttonsStyling: false,
          reverseButtons: true,
          showLoaderOnConfirm: true,
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value !== 'CONFIRMA') {
                resolve('Por favor, digite a palavra `CONFIRMA` para continuar');
              } else {
                resolve();
              }
            });
          },
          preConfirm: (confirm) => {
            return this.$store.dispatch('removeUser', payload.id);
          }
        }).then(response => {
          if (response.dismiss) {
            return;
          }
          switch (response.value.status) {
            case 'success':
              toastr({
                icon: 'success',
                title: 'Remoção de usuário',
                html: response.value.message,
                showCancelButton: true,
                confirmButtonClass: 'btn btn-default btn-lg float-right',
                cancelButtonClass: 'btn btn-default invisible btn-lg float-left',
                buttonsStyling: false,
                confirmButtonText: trans('words.close'),
                reverseButtons: true
              });
              this.fetchFiles(1);
              break;
            default:
              toastr({
                icon: response.value.status,
                title: 'Remoção de usuário',
                html: response.value.message,
                showCancelButton: true,
                allowOutsideClick: true,
                cancelButtonText: trans('words.close'),
                confirmButtonText: trans('words.close'),
                confirmButtonClass: 'btn btn-default btn-lg float-right',
                cancelButtonClass: 'btn btn-default btn-lg float-left invisible',
                buttonsStyling: false,
                reverseButtons: true
              });
              break;
          }
        });
      },
      getById(payload) {
        this.filterable.loading = true;
        this.$store
          .dispatch('getUserById', payload)
          .then(response => {
            this.filterable.loading = false;
            this.usuario = response;
            $('#ModalShowData').modal('toggle');
          });
      },
      disableUser(payload) {
        this.isLoading = true;
        this.$store.dispatch('disableUser', payload).then(response => {
          toastr({
            icon: response.status,
            title: response.message
          });
          this.$store.commit('UPDATE_USER_LIST', payload);
          this.isLoading = false;
        });
      }
    }
  };
</script>